import type { DocumentItem } from "@/types/ui-models";
import { NoRealData } from "@/components/shared";
import DocumentTypeBadge from "./DocumentTypeBadge";
import DocumentStatusBadge from "./DocumentStatusBadge";
import { fmtDate } from "../lib/docUtils";

interface TreeSourcesTableProps {
  documents: DocumentItem[];
  onViewDocument: (id: string) => void;
}

export default function TreeSourcesTable({ documents, onViewDocument }: TreeSourcesTableProps) {
  const treeDocs = documents.filter((d) => d.ctaCode !== null);

  if (treeDocs.length === 0) {
    return (
      <NoRealData
        title="Nenhum documento vinculado a exemplar arbóreo"
        description="Documentos cadastrados com vínculo a um exemplar do CTA aparecem aqui."
        icon="ri-plant-line"
      />
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Documentos vinculados a exemplares arbóreos</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 text-left">
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Código CTA</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Tipo de fonte</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Documento</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Status</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Emissão</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {treeDocs.map((doc) => (
              <tr key={doc.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3">
                  <span className="text-sm font-mono font-semibold text-foreground-800">{doc.ctaCode}</span>
                </td>
                <td className="py-2.5 px-3"><DocumentTypeBadge type={doc.type} /></td>
                <td className="py-2.5 px-3">
                  <button onClick={() => onViewDocument(doc.id)} className="text-sm font-medium text-foreground-800 hover:text-accent-600 transition-colors text-left max-w-[200px] truncate block">
                    {doc.title}
                  </button>
                </td>
                <td className="py-2.5 px-3"><DocumentStatusBadge status={doc.status} /></td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 whitespace-nowrap">{fmtDate(doc.issueDate)}</td>
                <td className="py-2.5 px-3">
                  <button onClick={() => onViewDocument(doc.id)} className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center text-foreground-500 hover:text-accent-600 transition-colors" title="Visualizar">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
